import { render, staticRenderFns } from "./MathCalendar.vue?vue&type=template&id=16589596&scoped=true"
import script from "./MathCalendar.vue?vue&type=script&lang=js"
export * from "./MathCalendar.vue?vue&type=script&lang=js"
import style0 from "./MathCalendar.vue?vue&type=style&index=0&id=16589596&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16589596",
  null
  
)

export default component.exports